import PhotoSwipe from "photoswipe"
import "photoswipe/style.css"

const videoModalButtons = document.querySelectorAll(
  ".video-modal-button, .youtube-systems-overview",
)
videoModalButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault()
    const embed = button.href
    const options = {
      dataSource: [
        {
          html: `<div class="video-slide"><iframe width="560" height="315" src="${embed}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`,
        },
      ],
    }

    options.index = 0
    const pswp = new PhotoSwipe(options)
    pswp.init()
  })
})
